import "./OperatorPermissionCheck.scss";
import Button from 'components/Button/Button';
import InputField from 'components/InputField/InputField';
import { useRef, useState } from 'react';
import { listOperatorUsers } from "pages/OperatorPermissionCheck/graphql";
import { useMutation } from '@apollo/client';
import { displaySuccess, displayError } from 'utils/displayNotification';
import { ListOperatorPermissionsInput, ListOperatorUsersResponse } from "TypesAndInterfaces";

interface IProps {
  marketplaceId?: number
}


const OperatorPermissionCheck = ({
  marketplaceId
}: IProps) => {
  const [operatorEmail, setOperatorEmail] = useState("");
  const operatorSyncRef = useRef(null);
  const [listPermissions] = useMutation<ListOperatorUsersResponse, { params: ListOperatorPermissionsInput }>(listOperatorUsers, {
    onCompleted: (data) => {
      const result = data.listOperatorUsers;
      if (result?.status === "OK") {
        displaySuccess("Requested operator has all the required permissions.");
      } else if (result?.status === "NOK") {
        if (result?.missingRoles?.length) {
          displayError(`Operator is missing the following required permissions: ${result.missingRoles.join(", ")}`);
        } else {
            displayError("It seems that the requested operator does not exist in the marketplace.");
        }
      }
    },
    onError: (e) => {
      console.error("listPermissions error", e);
    },
  });

  const validateEmail = (email: string) => {
    // Regex: text + @ + text + . + 1-5 chars
    const emailRegex = /^[^@]+@[^@]+\.[a-zA-Z]{1,5}$/;
    if (emailRegex.test(email)) {
      if (marketplaceId !== undefined) {
        listPermissions({
          variables: { params: { marketplaceId, email } }
        });
      } else {
        displayError("Marketplace ID is required.");
      }
    } else {
      displayError("Please enter a valid email address.");
    }
  };

  return (
    <span className="schedule-container">
      <InputField
        innerRef={operatorSyncRef}
        label="Operator e-mail"
        value={operatorEmail}
        onChange={(e) => setOperatorEmail(e.currentTarget.value)}
        className="shop-ids-input"
      />
      <Button
        className="button--bordered button--green button-less-padding admin-view-class"
        type="button"
        content="Check Operator Permissions"
        onClick={() => validateEmail(operatorEmail)}
      ></Button>
    </span>
  );
};

export default OperatorPermissionCheck;

